import {RefreshCw} from 'lucide-react';
export function RefreshIcon({busy,disabled,onClick,label='Refresh'}:{busy:boolean;disabled?:boolean;onClick:()=>void;label?:string}){
 return <button type="button" className="pb-icon-button" aria-label={busy?'Refreshing':label} title={label} disabled={busy||disabled} onClick={onClick}><RefreshCw size={19} className={busy?'op-spin':undefined}/></button>;
}
